import { pageTrackerIsAllowed } from 'shared/helpers/pageTrackerTools'

type WindowWithDataLayer = Window & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataLayer: Record<string, any>[]
}

declare const window: WindowWithDataLayer

export const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID

export const pageView = (path: string) => {
  const trackingObject = {
    event: 'pageview',
    pagePath: path,
    pageUrl: window.location.href
  }
  if (pageTrackerIsAllowed) {
    window.dataLayer.push(trackingObject)
  } else {
    console.log({
      pageTrackerIsAllowed: pageTrackerIsAllowed,
      ...trackingObject
    })
  }
}
